<template>
  <el-breadcrumb class="app-breadcrumb" :separator-icon="ArrowRight">
    <!-- <transition-group name="breadcrumb"> -->
      <el-breadcrumb-item v-for="(item, index) in levelList" :key="item.path">
        <span
          v-if="item.redirect === 'noRedirect' || index == levelList.length - 1"
          class="no-redirect"
          >{{ item.meta.title }}</span
        >
        <a v-else @click.prevent="handleLink(item)">{{ item.meta.title }}</a>
      </el-breadcrumb-item>
    <!-- </transition-group> -->
  </el-breadcrumb>
</template>

<script setup>
import { ArrowRight } from '@element-plus/icons-vue'
import { ref, watchEffect,getCurrentInstance } from "vue";
const {
    appContext: {
      config: { globalProperties: global },
    },
  } = getCurrentInstance();

const route = global.$route;
const router = global.$router;
const levelList = ref([]);

function getBreadcrumb() {
  // only show routes with meta.title
  
  // console.log("route.matched:",route);
  let matched = route.matched.filter((item) => item.meta && item.meta.title);
  levelList.value = matched.filter(
    (item) => item.meta && item.meta.title && item.meta.breadcrumb !== false
    );
    console.log("levelList.value:",levelList.value);
  
}
function handleLink(item) {
  const { redirect, path } = item;
  if (redirect) {
    router.push(redirect);
    return;
  }
  router.push(path);
}

watchEffect(() => {
  // if you go to the redirect page, do not update the breadcrumbs
  if (route.path.startsWith("/redirect/")) {
    return;
  }
  getBreadcrumb();
});
getBreadcrumb();
</script>

<style lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  display: flex;
  align-items: baseline;
  font-size: 14px;
  margin: 6px 0;

  .no-redirect {
    color: #55606E;
    cursor: text;
  }
  .el-breadcrumb__item:last-child{
    .no-redirect{
      font-size: 18px;
      color:#0C0C0D;
    }
  }
}
</style>
